import { exerciseActions } from "./actions";
import { exerciseState } from "./state";
import { exerciseGetters } from "./getters";
import { exerciseMutations } from "./mutations";

const exerciseModule = {
  namespaced: true,
  actions: exerciseActions,
  getters: exerciseGetters,
  mutations: exerciseMutations,
  state: exerciseState
};

export { exerciseModule };
